export enum SIDEBAR {
  SET_BILL_DATE = 'coBillingSubscription',
  VIEW_PRICING_DETAILS = 'viewPricingDetails',
  OPTOUT_TRIAL = 'optout_trial',
  SET_INVOICE_GROUP = 'set_invoice_group',
  CHANGE_SUBSCRIPTION = 'change-subscription',
  ADD_CUSTOMER_CONTACT = 'add_customer_contact',
}
